import React, { useState } from 'react';
import styles from '../styles/AddModal.module.css';     
import CustomSelect from '../customComponents/CustomSelect';
import { API_URL } from '../config/api';


const AddCustomerModal = ({ onClose, onCustomerAdded }) => {
  const [form, setForm] = useState({
    sn: '',
    org_type: 'individual',
    name: '',
    phone: '',
    city: '',
    address: '',
  });
  const [loading, setLoading] = useState(false);

  const options = [
    { label: 'ИП', value: 'individual' },
    { label: 'ТОО', value: 'llp' },
    { label: 'АО', value: 'jsc' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.sn || !form.name) {
      alert('Пожалуйста, заполните ИИН/БИН и имя клиента');
      return;
    }

    setLoading(true);
    const token = localStorage.getItem('token');

    const payload = {
      ...form,
      type: 'client',
    };

    try {
      const res = await fetch(`${API_URL}/api/contractors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '', 
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        console.error('Ошибка при добавлении клиента:', data);
        alert(data.errors?.message || 'Ошибка при добавлении клиента');
        setLoading(false);
        return;
      }

      onCustomerAdded();
      setForm({
        sn: '',
        org_type: 'individual',
        name: '',
        phone: '',
        city: '',
        address: '',
      });
      onClose();
    } catch (err) {
      console.error('Ошибка запроса:', err);
      alert('Произошла ошибка при добавлении клиента');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2 className={styles.headText}>Добавить клиента</h2>
        <input
          name="sn"
          placeholder="ИИН/БИН"
          value={form.sn}
          onChange={handleChange}
        />
        <CustomSelect
          options={options}
          value={form.org_type}
          onChange={(val) => setForm((prev) => ({ ...prev, org_type: val }))}
          placeholder="Тип организации"
        />
        <input
          name="name"
          placeholder="Имя клиента"
          value={form.name}
          onChange={handleChange}
        />
        <input
          name="phone"
          placeholder="Телефон"
          value={form.phone}
          onChange={handleChange}
        />
        <input
          name="city"
          placeholder="Город"
          value={form.city}
          onChange={handleChange}
        />
        <input
          name="address"
          placeholder="Адрес"
          value={form.address}
          onChange={handleChange}
        />
        <div className={styles.modalActions}>
          <button className={styles.cancel} onClick={onClose} disabled={loading}>Отмена</button>
          <button className={styles.save} onClick={handleSubmit} disabled={loading}>
            {loading ? 'Сохраняем...' : 'Сохранить'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerModal;
